import React, { useState, useEffect, useRef } from 'react';
import { Button, Input, Modal } from 'antd';
import { connect } from 'react-redux';
import QRCodeImage from 'qrcode.react';
import QRCodePrint from 'react-qr-code';

import ListView from './Utils/ListView';
import { constant } from './Utils/constants';
import translation from './Utils/translation';
import Highlighter from 'react-highlight-words';
import { getMasterList } from './Utils/FormCalls';
import { SearchOutlined } from '@ant-design/icons';
import { API_DEVICE } from '../../../../commons/api';
import { exportComponentAsJPEG } from 'react-component-export-image';
import themeSettings from '../../../../commons/styles/themeSettings.json';
import { StyledHomepage } from '../../../../commons/styles/layout';

const urlList = {
  list: `${API_DEVICE.GetScannersList}`
};

const QrList = (props) => {
  const [state, setState] = useState({
    dataSource: [],
    viewQRModal: false,
    SpecificationData: [],
    activeKey: '1',
    form: {},
    translationCache: props.translationCache || [],
    userProfile: props.userProfile || {},
    userList: [],
    config: {
      viewTypes: ['add'],
      defaultViewType: 'table',
      filterType: 'ByAttributeValue',
      attributeList: ['QRCode', 'Description'],
      firstTitle: 'QRCode',
      secondTitle: 'CreatedBy',
      thirdTitle: 'CreatedTime',
      actions: ['edit', 'delete'],
      edit: {
        byAttribute: 'ScannerId',
        redirectURL: '/rubus/QrDetails'
      }
    }
  });

  const [searchText, setSearchText] = useState('');
  const [value, setValue] = useState('');
  const imageRef = useRef(null);
  const searchInput = useRef(null);

  useEffect(() => {
    _getAdhocDataSource();
  }, []);

  useEffect(() => {
    if (props.translationCache !== state.translationCache) {
      setState(prevState => ({ ...prevState, translationCache: props.translationCache }));
    }
    if (props.match.params.Masters !== state.mastername) {
      let mastername = props.match.params.Masters;
      _getAdhocDataSource();
      setState(prevState => ({ ...prevState, mastername }));
    }
    if (props.userProfile !== state.userProfile) {
      setState(prevState => ({ ...prevState, userProfile: props.userProfile }));
    }
  }, [props.translationCache, props.match.params.Masters, props.userProfile]);

  const _getAdhocDataSource = async () => {
    let dataSource = await getMasterList(urlList.list);
    setState(prevState => ({
      ...prevState,
      dataSource,
      activeKey: '1',
      form: {}
    }));
  };

  const onModalOk = () => {
    setState(prevState => ({ ...prevState, viewQRModal: false }));
  };

  const editAssetMaster = async (record) => {
    setState(prevState => ({
      ...prevState,
      viewQRModal: true
    }));
    setValue(record.ScannerId);
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, `Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
        >
          {translation(props.translationCache, 'Search')}
        </Button>
        <Button onClick={() => handleReset(clearFilters, confirm)} >
          {translation(props.translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: () => (
      <SearchOutlined style={{ color: 'white', }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const print = () => {
    const printablecontent = document.getElementById('print').innerHTML;
    const printwindow = window.open('', '_blank', '', '');
    printwindow.document.write(printablecontent);
    printwindow.print();
    printwindow.close();
  };

  const columns = [
    {
      title: translation(props.translationCache, constant.scannerID),
      dataIndex: 'ScannerId',
      key: 'ScannerId',
      filter: true,
      ...getColumnSearchProps('ScannerId')
    },
    {
      title: translation(props.translationCache, constant.equipment),
      dataIndex: 'DisplayCode',
      key: 'DisplayCode',
      ...getColumnSearchProps('DisplayCode')
    },
    {
      title: translation(props.translationCache, constant.equipmentDescription),
      dataIndex: 'Device_Description',
      key: 'Device_Description',
      filter: true
    },
    {
      title: translation(props.translationCache, constant.location),
      dataIndex: 'Location_DisplayCode',
      key: 'Location_DisplayCode',
      ...getColumnSearchProps('Location_DisplayCode')
    },
    {
      title: translation(props.translationCache, constant.locationDescription),
      dataIndex: 'Location_Description',
      key: 'Location_Description',
      filter: true
    },
    {
      title: translation(props.translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>
          <Button
            onClick={() => editAssetMaster(record)}            
          >
            {translation(props.translationCache,'View QR')}
          </Button>
        </>
      )
    }
  ];

  const config = {
    title: translation(props.translationCache, constant.QrCodeList),
    viewTypes: ['add'],
    defaultViewType: 'table',
    filterType: 'ByAttributeValue',
    attributeList: ['Item', 'Description'],
    firstTitle: 'QrList',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedTime',
    actions: ['edit', 'delete'],
    edit: {
      byAttribute: 'ScannerId',
      redirectURL: '/rubus/QrDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  return (
    <StyledHomepage>
      <ListView
        {...props}
        columns={columns}
        dataSource={state.dataSource}
        userList={state.userList}
        config={config}
        // delete={_deleteById}
      />
      <Modal
        open={state.viewQRModal}
        style={{ height: 500 }}
        closable
        title={translation(props.translationCache, constant.viewQr)}
        okText={translation(props.translationCache, 'Ok')}
        cancelText={translation(props.translationCache, 'Cancel')}
        onOk={onModalOk}
        onCancel={onModalOk}
      >
        <div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div
              ref={imageRef}
              style={{
                height: 340,
                width: 420
              }}
            >
              <p style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                {'ScannerId'}:{value}
              </p>

              <QRCodeImage
                id="QRIMAGE"
                style={{ marginLeft: '110px' }}
                value={`${JSON.stringify({ ScannerId: value })}`}
                size={220}
                // onError={handleError}
                // onScan={handleScan}
              />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '50px',
              marginBottom: '40px'
            }}
          >
            <Button
              theme={themeSettings}
              style={{ marginRight: '50px' }}
              onClick={() => exportComponentAsJPEG(imageRef)}
            >
              {translation(props.translationCache, constant.SaveImage)}
            </Button>

            <Button
              theme={themeSettings}
              style={{ marginRight: '6px' }}
              onClick={print}
            >
              {translation(props.translationCache, constant.PrintImage)}
            </Button>
          </div>
          {
            <div
              id="print"
              style={{
                display: 'flex',
                justifyContent: 'center',
                opacity: 0,
                marginLeft: '950px',
                height: 240,
                width: 320,
                backgroundColor: 'white'
              }}
            >
              <p
                size={400}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '180px'
                }}
              >
                {'ScannerId'}:{value}
              </p>
              <QRCodePrint
                display={false}
                id="QRPrint"
                style={{ marginLeft: '120px' }}
                value={`${JSON.stringify({ ScannerId: value })}`}
                size={400}
                // onError={handleError}
                // onScan={handleScan}
              />
            </div>
          }
        </div>
      </Modal>
    </StyledHomepage>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(QrList);
